import { APP } from "@fusiqo/vozqi-shared";
import { getBaseUrl } from "./config";

/** The API's base URL, or null for a build without one: the callers degrade, they do not fail. */
export function apiBaseOrNull(): string | null {
  try {
    return getBaseUrl();
  } catch {
    return null;
  }
}

/**
 * WHERE A STORE BADGE GOES, with the link's campaign on board. Through the
 * API's counter when this build has one (`GET /acquisition/store/<store>`,
 * spec «Embudo para técnicos» §2.5): it counts the tap and answers 302 to the
 * store with the tags -- Play's install referrer, the App Store's `ct`. A
 * build without the API gets the plain listing. `query` is what the counter
 * reads -- the tags and the trade, without the `?` -- and may be "".
 */
export function storeHref(api: string | null, store: "ios" | "android", query: string): string {
  if (api === null) return store === "ios" ? APP.stores.appStore : APP.stores.googlePlay;
  const counter = `${api}/acquisition/store/${store}`;
  return query === "" ? counter : `${counter}?${query}`;
}
